/**
 * `/locations/:slug` unified router (Feb 2026 · National SEO Architecture).
 *
 * A single segment under `/locations/` could be:
 *
 *   • A country slug — currently only `australia`
 *   • A state slug — currently only `queensland`
 *   • A legacy suburb slug — e.g. `doonan-water-testing`
 *
 * React Router v6 can't disambiguate these based on static config, so
 * this component branches at render time. Legacy suburbs are served
 * exactly as before (LocationLanding) — no user-visible URL change.
 * Country and state slugs render the new hub components.
 */
import { useParams } from "react-router-dom";
import AustraliaHub from "@/pages/locations/AustraliaHub";
import StateHub from "@/pages/locations/StateHub";
import LocationLanding from "@/pages/LocationLanding";
import { COUNTRIES, STATES } from "@/data/locationTree";

export default function LocationTopLevelRouter() {
  const { slug } = useParams();
  const norm = (slug || "").toLowerCase();
  if (COUNTRIES[norm]) return <AustraliaHub />;
  if (STATES[norm])    return <StateHub />;
  return <LocationLanding />;
}
